const LEVEL_BLOCAGE = {
  libre: 'Libre',
  limitePaiementComptant: 'Limité au paiement comptant',
  total: 'Totalement bloqué',
};

export default LEVEL_BLOCAGE;
